// File: src/components/forms/CountrySelector/CountrySelector.tsx

import React from "react";
import { SmartSelect } from "../../general/SmartSelect";
import { countries } from "./countries";

interface CountryOption {
  label: string;
  value: string;
}

export interface CountrySelectorProps {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
}

export const CountrySelector: React.FC<CountrySelectorProps> = ({
  label = "Country",
  placeholder = "Select your country",
  value = "",
  onChange,
  disabled = false,
}) => {
  const options: CountryOption[] = countries.map((c) => ({
    label: c.name,
    value: c.code,
  }));

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <SmartSelect
      label={label}
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};